import React from "react";
import ourteamcardstyles from "./ourteamcard.module.css";

function OurTeamCard({ imagesrc, name, title }) {
  return (
    <div className={ourteamcardstyles.ourteamCardWrap}>
      <div className={ourteamcardstyles.ourteamImage}>
        <img src={imagesrc} alt="team" />
      </div>

      <div className={ourteamcardstyles.ourteamContent}>
        <h5>{name}</h5>
        <p>{title}</p>
      </div>
    </div>
  );
}

export default OurTeamCard;
